(function ($) {
  "use strict";

  // zelfde breakpoint als je theme (pas aan indien anders)
  var DESKTOP_BP = 1200;

  function isDesktop() {
    return window.matchMedia(`(min-width:${DESKTOP_BP}px)`).matches;
  }

  function megaMenu() {
    if (!isDesktop()) return; // niets doen op mobiel

    // vind de rij waarin je nav staat
    var parentRow = $("#header .page-full-width > .row");
    if (!parentRow.length) parentRow = $("#header .page-width .row");
    if (!parentRow.length) return;

    var parentLeft = parentRow.css("marginLeft")
      ? parseInt(parentRow.css("marginLeft"), 10)
      : (parentRow.offset() ? parentRow.offset().left : 0);

    var parentWidth = parentRow.width() || $(window).width();

    // elke top-level <li> met mega menu
    $("#header .dt-nav > li.has-mega-menu").each(function () {
      var $li = $(this);
      var $panel = $li.children(".mega-panel"); // NIEUWE selector
      if (!$panel.length) return; // safety

      // breedte binnen container/viewport houden
      var maxW = Math.min(parentWidth, window.innerWidth - 32); // kleine gutter
      $panel.css("width", maxW + "px");
    });

    // sticky-header kopie (als die bestaat in je DOM)
    $("sticky-header .dt-nav > li.has-mega-menu").each(function () {
      var $li = $(this);
      var $panel = $li.children(".mega-panel");
      if (!$panel.length) return;
      var maxW = Math.min(parentWidth, window.innerWidth - 32);
      $panel.css("width", maxW + "px");
    });

    // force een layout pass
    window.setTimeout(function () { $(window).trigger("resize"); }, 100);
  }

  // Run once en op resize (desktop only)
  $(document).ready(megaMenu);
  var scheduled = false;
  $(window).on("resize", function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      megaMenu();
    });
  });

  // ===== Tabs =====
  // Desktop tabs
  $(document).on("click", ".deskTabs a", function (e) {
    if (!isDesktop()) return;      // geen desktop → niets doen
    e.preventDefault();
    var id = $(this).attr("href");
    var $tabs = $(this).closest(".deskTabs");
    $tabs.find("li").removeClass("active");
    $(this).parent().addClass("active");
    var $scope = $tabs.closest(".tabs-nav");
    $scope.find(".tabs-content li.dt-sc-menu-tabs").hide();
    $scope.find(id).show();
  });

  // Mobiele accordion
  $(document).on("click", ".mobileTabs .tabs li", function () {
    if (isDesktop()) return;
    $(this).next("div").slideToggle(0);
  });

  // Category button
  $(document).on("click", "#category-menu-button", function () {
    $(this).toggleClass("open");
    $(".category-wrapper").toggleClass("open").slideToggle(0);
  });

})(jQuery);
